import {FC} from 'react';
import clsx from 'clsx';
import BaseRadioButton from 'components/Form/Base/BaseRadioButton';

type MailpointPresetOptionsProps = {
    hide: boolean;
    options: number[];
};

const MailpointPresetOptions: FC<MailpointPresetOptionsProps> = ({
    hide,
    options,
}) => (
    <div className={clsx('w-full', hide && 'hidden')}>
        <BaseRadioButton
            isHorizontal={true}
            name="mailpoints"
            options={options.map((option) => ({
                label: option.toString(),
                value: option.toString(),
            }))}
        />
    </div>
);

export default MailpointPresetOptions;
